<template>
  <Transition name="modal">
    <div class="modal-mask">
      <notifications group="modal" />
      <div class="modal-wrapper" @click.stop="$emit('backdrop-click')">
        <div class="modal-container" @click.stop="">
          <div class="modal-header">
            <slot name="header">
              <h4 class="modal-title" id="myModalLabel">
                {{ title }}
              </h4>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  emits: ["backdrop-click"],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: max-content;
  width: 100%;
  margin: 0px auto;
  padding: 0 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  white-space: normal;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-default-button {
  float: right;
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal__notification {
  z-index: 15;
}

.panel-body__text {
  text-align: center;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 1023px) {
  .modal-container {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/Modal.vue